    <kendo-dialog-titlebar>
        <div class="k-d-flex k-justify-content-space-between k-align-items-center title">
            <fa-icon icon="triangle-exclamation" class="k-mr-2" style="font-size: 24px;"></fa-icon>
            <h4 class="k-m-0">Warning</h4>
        </div>
    </kendo-dialog-titlebar>
    <kendo-dialog-messages>
            {{action == 'markAbove' ? 'Marking as done will remove the alert(s) from this popup. You will need to go to the “All Notifications”
            page to find them again. Are you sure you want to mark as done?' : 'This will mark all notifications associated with your account as done/read. Are you sure you want to continue?'}}
    </kendo-dialog-messages>
    <kendo-dialog-actions>
      <div class="k-d-flex k-flex-col k-gap-4 k-w-100">
        <!-- <div class="k-d-flex k-align-items-center k-gap-2">
          <input type="checkbox" size="medium" kendoCheckBox #dontShow [(ngModel)]="dontShowAgain" />
          <kendo-label class="k-checkbox-label" text="
                  Do not show this warning again
                  " [for]="dontShow">
          </kendo-label>
        </div> -->
        <button kendoButton themeColor="error" fillMode="solid" (click)="confirmMarking()">
            Confirm and Continue
        </button>
      </div>
    </kendo-dialog-actions>